/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceHomeHealthPractitionerAssignmentRole
 */
export interface ReplaceHomeHealthPractitionerAssignmentRole {
    /**
     * One of the canonical roles, or null for an assignment with no specific role.
     */
    role: ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum | null;
    /**
     * 
     */
    selected: boolean;
    /**
     * 
     */
    expected_assignment?: ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum;
    /**
     * 
     */
    expected_updated_at?: Date;
    /**
     * 
     */
    reassign?: boolean;
}


/**
 * @export
 */
export const ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum = {
    InitialReferring: 'INITIAL_REFERRING',
    F2FEncounter: 'F2F_ENCOUNTER',
    F2FCertifying: 'F2F_CERTIFYING',
    PlanOfCareSigning: 'PLAN_OF_CARE_SIGNING',
} as const;
export type ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum = typeof ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum[keyof typeof ReplaceHomeHealthPractitionerAssignmentRoleRoleEnum];

/**
 * @export
 */
export const ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum = {
    Absent: 'absent',
} as const;
export type ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum = typeof ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum[keyof typeof ReplaceHomeHealthPractitionerAssignmentRoleExpectedAssignmentEnum];


/**
 * Check if a given object implements the ReplaceHomeHealthPractitionerAssignmentRole interface.
 */
export function instanceOfReplaceHomeHealthPractitionerAssignmentRole(value: object): value is ReplaceHomeHealthPractitionerAssignmentRole {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('selected' in value) || value['selected'] === undefined) return false;
    return true;
}

export function ReplaceHomeHealthPractitionerAssignmentRoleFromJSON(json: any): ReplaceHomeHealthPractitionerAssignmentRole {
    return ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceHomeHealthPractitionerAssignmentRole {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'selected': json['selected'],
        'expected_assignment': json['expected_assignment'] == null ? undefined : json['expected_assignment'],
        'expected_updated_at': json['expected_updated_at'] == null ? undefined : (parseDateTime(json['expected_updated_at'])),
        'reassign': json['reassign'] == null ? undefined : json['reassign'],
    };
}

export function ReplaceHomeHealthPractitionerAssignmentRoleToJSON(json: any): ReplaceHomeHealthPractitionerAssignmentRole {
    return ReplaceHomeHealthPractitionerAssignmentRoleToJSONTyped(json, false);
}

export function ReplaceHomeHealthPractitionerAssignmentRoleToJSONTyped(value?: ReplaceHomeHealthPractitionerAssignmentRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'selected': value['selected'],
        'expected_assignment': value['expected_assignment'],
        'expected_updated_at': value['expected_updated_at'] == null ? value['expected_updated_at'] : serializeDateTime(value['expected_updated_at']),
        'reassign': value['reassign'],
    };
}

